import { FC, ReactElement, useEffect, useState } from 'react';
import { Stack, StackProps, SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as LogoPrimary } from '@assets/logo/logo-primary.svg';
import { ReactComponent as LogoWhite } from '@assets/logo/logo-white.svg';
import { ReactComponent as LogoPrimarySmall } from '@assets/logo/logo-primary-small.svg';
import { ReactComponent as LogoWhiteSmall } from '@assets/logo/logo-white-small.svg';
import { ReactComponent as LogoIT } from '@assets/logo/logo-IT.svg';
import { ReactComponent as LogoDealer } from '@assets/logo/logo-dealer.svg';
import { useLoggedinUser } from '@hooks/useLoggedingUser';

export type LogoVariant = 'primary' | 'white';
export type LogoSize = 'small' | 'normal';
const LogoMap: Record<LogoVariant, Record<LogoSize, any>> = {
	primary: {
		small: LogoPrimarySmall,
		normal: LogoPrimary
	},
	white: {
		small: LogoWhiteSmall,
		normal: LogoWhite
	}
};

export interface ILogoProps extends StackProps {
	variant?: LogoVariant;
	size?: LogoSize;
	roleIdentifier?: boolean;
	svgIconProps?: SvgIconProps;
}

export const Logo: FC<ILogoProps> = ({
	variant = 'primary',
	size = 'normal',
	roleIdentifier,
	svgIconProps: { sx: svgIconSx, ...svgIconProps } = {},
	sx,
	...props
}) => {
	const user = useLoggedinUser();
	const [roleIdentifierLogo, setRoleIdentifierLogo] = useState<ReactElement>();

	useEffect(() => {
		if (user?.isAdmin()) {
			setRoleIdentifierLogo(
				<SvgIcon
					component={LogoIT}
					viewBox="0 0 28 23"
					sx={{ marginLeft: '8px !important', marginTop: '8px !important', width: 28, height: 25 }}
				/>
			);
		} else if (user?.isDealer()) {
			setRoleIdentifierLogo(
				<SvgIcon component={LogoDealer} viewBox="0 0 57 24" sx={{ marginTop: '8px !important', width: 57, height: 24 }} />
			);
		} else {
			setRoleIdentifierLogo(undefined);
		}
	}, [user, roleIdentifier]);

	return (
		<Stack direction="row" spacing={0.5} alignItems="center" sx={{ ...sx }} {...props}>
			<SvgIcon
				component={LogoMap[variant][size]}
				sx={size === 'small' ? { width: 50, height: 50, ...svgIconSx } : { width: 160, height: 50, ...svgIconSx }}
				viewBox={size === 'small' ? '0 0 120 120' : '0 0 173 50'}
				{...svgIconProps}
			/>
			{roleIdentifier && size !== 'small' ? roleIdentifierLogo : null}
		</Stack>
	);
};
